import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsFetchFailed } from 'state/workspaces/workspace.actions';
import { workspaceTabsFetchedThunk } from 'state/workspaces/workspace.thunks';

export function fetchEssentialWorkspaceTabsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const api = tabsApiConnector(httpClient, 'essential');
    return action$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(({ workspace }) => workspace === 'essential'),
      mergeMap(({ tabFetchRequestId }) =>
        api.getAllTabDescriptions().pipe(
          map(({ tabs, activeTabId, isEssentialTabsPanelShown }) => {
            const actualActiveTabId: string | undefined = activeTabId ?? tabs[0]?.id ?? undefined;
            return workspaceTabsFetchedThunk(
              tabs,
              actualActiveTabId,
              'essential',
              tabFetchRequestId,
              isEssentialTabsPanelShown,
            );
          }),
          catchError((_: Error) => {
            return of(workspaceTabsFetchFailed('essential', tabFetchRequestId));
          }),
        ),
      ),
    );
  };
}
